<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="13" tab-hidden>
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_codes" field-name="背贴码"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="imeis" field-name="IMEI"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="订单号">
                            <c-input name="keyword" placeholder="订单/三方/快递单号"></c-input>
                        </m-search-item>
                        <m-search-item label="商品名称">
                            <c-input name="product_name"></c-input>
                        </m-search-item>
                        <m-search-item label="售卖类型">
                            <c-select name="sell_type" :options="SALE_SELL_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <c-table-column type="button" label="操作" width="160" fixed="right">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="$refs.detail.open(data)">详情</c-table-button>
                        <c-table-button icon="tf-detail" @click="viewQualityReport(data)">质检报告</c-table-button>
                        <!--取消订单：线下只有待收款（order_state==1）可取消，后端统一取消入口会拦已收款/已发货-->
                        <c-table-button v-if="auth('b_ops_offline_order_close') && data.order_state == 1" icon="tf-cancel" color="red" @click="openCloseDialog(data)">取消订单</c-table-button>
                    </template>
                </c-table-column>

                <template #order_no="{data}">
                    <div class="m-product-info">
                        <p>{{data.order_no || '-'}}</p>
                        <p v-if="data.pay_trade_number" class="m-product-info-code">支付单号：{{data.pay_trade_number || '-'}}</p>
                    </div>
                </template>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #product_info="{data}">
                    <m-product-info :name="data.product_name || getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
                </template>

                <template #level_type="{data}">
                    <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                </template>

                <template #produce_code="{data}">
                    {{data.produce_code}} <c-link color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #imei="{data}">
                    {{data.imei}} <c-link v-if="data.imei" color="gray" @click="$copy(data.imei)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #sell_type="{data}">
                    <c-state async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
                </template>

                <template #order_state="{data}">
                    <c-state async dict="SALES_ORDER_STATE" tag :value="getOrderDisplayState(data)"></c-state>
                    <c-tooltip v-if="data.abnormal_flag == 1" :tip="'异常订单' + (data.abnormal_remark ? '。原因：' + data.abnormal_remark : '')"><span class="m-abnormal-help">!</span></c-tooltip>
                </template>

                <template #sale_price="{data}">
                    <span style="color: #e53e3e;">{{formatPrice(data.sale_price)}}</span>
                </template>

                <template #cost_price="{data}">
                    {{formatPrice(data.cost_price)}}
                </template>

                <template #refund_info="{data}">
                    <span v-if="!Number(data.refund_amount)">-</span>
                    <div v-else class="m-product-info">
                        <p style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</p>
                        <p class="m-product-info-code">{{data.refund_date || '-'}}</p>
                    </div>
                </template>

                <template #receiver_info="{data}">
                    <div class="m-product-info">
                        <p v-if="data.receiver_name">{{data.receiver_name}}　{{data.receiver_phone}}</p>
                        <p v-if="data.receiver_address" class="m-product-info-code">{{data.receiver_address}}</p>
                        <p v-if="!data.receiver_name && !data.receiver_address">-</p>
                    </div>
                </template>

                <template #create_user_id="{data}">
                    {{data.create_user_realname || '-'}}
                </template>
            </view-list>
            <!--取消订单弹框：原因必填（后端要求），取消会释放商品占用，不可恢复-->
            <c-dialog ref="closeDialog" title="取消订单" width="520">
                <!--带底部按钮区的 c-dialog 内容区四边内边距为 0，需自己包一层加留白（同线上订单列表关闭弹框的写法）-->
                <div class="m-close-body">
                    <div class="m-close-tip">
                        确认取消线下订单【{{closingRow.order_no}}】吗？取消后不可恢复，商品占用会释放、恢复可售。
                    </div>
                    <div class="m-close-remark">
                        <p class="m-close-remark-label">取消原因</p>
                        <!--组件库 textarea 不认 rows 属性，行数用 height-resize 控制（同线上订单列表关闭弹框的写法）-->
                        <c-input v-model="closeRemark" type="textarea" maxlength="500" :height-resize="{minHeight: '90px'}" placeholder="请填写取消原因（必填）"></c-input>
                    </div>
                </div>
                <template #button>
                    <c-button size="dialog" color="main" :disabled="isSubmitting" @click="submitClose">确认取消</c-button>
                    <c-button size="dialog" :disabled="isSubmitting" @click="$refs.closeDialog.close()">再想想</c-button>
                </template>
            </c-dialog>
            <erp-order-detail ref="detail" :order-type="1"></erp-order-detail>
            <quality-report-view ref="qualityReport"></quality-report-view>
        </module>
    </page>
</template>

<script>
import ErpOrderDetail from './components/order_detail.vue';
import QualityReportView from './components/quality_report_view.vue';
import {asyncMapState} from '@/store';

export default {
    name: 'erp_offline_order',
    components: {ErpOrderDetail, QualityReportView},
    computed: {
        ...asyncMapState(['SALE_SELL_TYPE'])
    },
    data() {
        return {
            closingRow: {},//正在取消的订单行
            closeRemark: '',//取消原因
            isSubmitting: false//防止重复提交
        }
    },
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        /*********质检报告：订单行下发条码ID/背贴码，弹窗按商户切租户查询**********/
        viewQualityReport(data) {
            this.$refs.qualityReport.open(Object.assign({}, data, {
                product_code_id: data.product_unique_code_id,
                produce_unique_code: data.produce_code
            }));
        },
        // 线下统一显示状态：售后优先，业务操作仍使用 order_state
        getOrderDisplayState(data) {
            const displayState = Number(data.display_state);
            if ([1, 2, 3, 4, 5, 9, 10, 11].includes(displayState)) {
                return displayState;
            }
            return data.order_state;
        },
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /*********取消订单：打开原因弹框**********/
        openCloseDialog(data) {
            this.closingRow = data;
            this.closeRemark = '';
            this.$refs.closeDialog.open();
        },
        /*********提交取消订单：调运营端统一取消接口，传目标商户和订单**********/
        submitClose() {
            if (this.isSubmitting) return;
            if (!this.closeRemark.trim()) {
                this.$message({message: '请填写取消原因', type: 'warn'});
                return;
            }
            this.isSubmitting = true;
            this.request({
                url: '/sale/order/ops/cancel',
                data: {
                    merchant_id: this.closingRow.saas_id,
                    order_id: this.closingRow.order_id,
                    remark: this.closeRemark.trim()
                },
                loading: true,
                success: (data, msg) => {
                    this.$refs.closeDialog.close();
                    this.$message({message: msg || '取消订单成功', type: 'success'});
                    this.$refs.view.update();
                },
                complete: () => {
                    this.isSubmitting = false;
                }
            });
        }
    }
};
</script>

<style scoped>
.m-product-info {line-height: 24px; font-size: 13px; color: #333;}
.m-product-info p {margin: 0;}
.m-product-info-code {color: #999; font-size: 12px;}
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
.m-close-body {padding: 20px 24px;}
.m-close-tip {margin-bottom: 12px; padding: 10px 12px; background: #fff7e6; border: 1px solid #ffe7ba; border-radius: 4px; font-size: 13px; line-height: 20px; color: #333;}
.m-close-remark-label {margin-bottom: 8px; font-size: 13px; font-weight: bold; color: #333;}
.m-abnormal-help {display: inline-flex; align-items: center; justify-content: center; width: 14px; height: 14px; margin-left: 4px; border: 1px solid #e53e3e; border-radius: 50%; font-size: 10px; color: #e53e3e; cursor: pointer; vertical-align: middle;}
</style>
